(function () {
  'use strict';

  function numeroParaMoedaExtenso(valor) {
    const unidades = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
    const especiais = [
      'dez',
      'onze',
      'doze',
      'treze',
      'quatorze',
      'quinze',
      'dezesseis',
      'dezessete',
      'dezoito',
      'dezenove',
    ];
    const dezenas = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
    const centenas = [
      '',
      'cento',
      'duzentos',
      'trezentos',
      'quatrocentos',
      'quinhentos',
      'seiscentos',
      'setecentos',
      'oitocentos',
      'novecentos',
    ];

    function numeroPorExtenso(n) {
      if (n < 10) return unidades[n];
      if (n < 20) return especiais[n - 10];
      if (n < 100) return dezenas[Math.floor(n / 10)] + (n % 10 !== 0 ? ' e ' + unidades[n % 10] : '');
      if (n < 1000) {
        if (n === 100) return 'cem';
        return centenas[Math.floor(n / 100)] + (n % 100 !== 0 ? ' e ' + numeroPorExtenso(n % 100) : '');
      }
      if (n < 1000000) {
        const milhar = Math.floor(n / 1000);
        const resto = n % 1000;
        return (
          (milhar > 1 ? numeroPorExtenso(milhar) + ' mil' : 'mil') + (resto !== 0 ? ' ' + numeroPorExtenso(resto) : '')
        );
      }
      return '';
    }

    function converteParteInteira(n) {
      if (n === 0) return '';
      if (n === 1) return 'um real';
      if (n > 1 && n < 2) return 'um real';
      return numeroPorExtenso(n) + ' reais';
    }

    function converteParteDecimal(n) {
      if (n === 0) return '';
      if (n === 1) return 'um centavo';
      return numeroPorExtenso(n) + ' centavos';
    }

    const [inteira, decimal] = valor.toFixed(2).split('.');
    const parteInteira = parseInt(inteira, 10);
    const parteDecimal = parseInt(decimal, 10);

    let extenso =
      converteParteInteira(parteInteira) +
      (converteParteInteira(parteInteira) && converteParteDecimal(parteDecimal) ? ' e ' : '') +
      converteParteDecimal(parteDecimal);

    // Transformando a primeira letra em maiúscula
    return extenso.charAt(0).toUpperCase() + extenso.slice(1);
  }

  // Campo do saque
  const $input = $('.cashout-amount-input');
  if ($input.length) {
    const $inputView = $('.cashout-amount-view');
    $input.on('keyup change', function () {
      let curVal = $input.val() ? formatMoneyBD($input.val()) : 0;
      curVal = Number(curVal);
      if (curVal > 0) {
        $inputView.show();
        $inputView.text(numeroParaMoedaExtenso(curVal));
      } else {
        $inputView.hide();
        $inputView.text('');
      }
    });
    window.Parsley.addValidator('cashoutVal', {
      validateString: function (value, minVal, maxVal, instance) {
        value = Number(formatMoneyBD(value));
        if (value < minVal) {
          return $.Deferred().reject('O saque deve ser de no mínimo R$ ' + formatMoneyBR(minVal));
        }
        if (value > maxVal) {
          return $.Deferred().reject(
            'O valor do saque é maior que o valor do seu saldo de R$ ' + formatMoneyBR(maxVal),
          );
        }
        return true;
      },
      requirementType: 'string',
      messages: {
        'pt-br': 'O valor é inválido.',
      },
    });
  }
})();
